// extracted by mini-css-extract-plugin
export var chip = "_rz-2";
export var chipBody = "_rz-8";
export var chipHeader = "_rz-9";
export var chipWithKind = "_rz-7";
export var icon = "_rz-3";
export var kind = "_rz-a";
export var remove = "_rz-5";
export var removeIcon = "_rz-6";
export var row = "_rz-0";
export var rowHistorical = "_rz-1";
export var text = "_rz-4";